import MarketComponentDetailsDialogMobileView from "./mobile/MarketComponentDetailsDialog.mobile.view";
import MarketComponentDetailsDialogDesktopView from "./desktop/MarketComponentDetailsDialog.desktop.view";
import type MarketComponentDetailsDialogProperties from "./MarketComponentDetailsDialog.properties.ts";
import { useIsDesktopDevice } from "../../tools/hooks/useIsDesktopDevice.ts";
import { useIsMobileDevice } from "../../tools/hooks/useIsMobileDevice.ts";

export default function MarketComponentDetailsDialogView(
  props: MarketComponentDetailsDialogProperties,
) {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      {isMobile && <MarketComponentDetailsDialogMobileView {...props} />}
      {isDesktop && <MarketComponentDetailsDialogDesktopView {...props} />}
    </>
  );
}
